/**
 * Theme definition following https://github.com/markdalgleish/react-themeable
 * for https://github.com/moroshko/a-search-auto#theme-optional
 * @type {{container: string, containerOpen: string, input: string, inputOpen: string, inputFocused: string, suggestionsContainer: string, suggestionsContainerOpen: string, suggestionsList: string, suggestion: string, suggestionFirst: string, suggestionHighlighted: string, sectionContainer: string, sectionContainerFirst: string, sectionTitle: string}}
 */

const SearchTheme = {
  container: 'a-search-auto__container',
  containerOpen: 'a-search-auto__container--open',
  input: 'a-search-auto__input',
  inputOpen: 'a-search-auto__input--open',
  inputFocused: 'a-search-auto__input--focused',
  suggestionsContainer: 'a-search-auto__suggestions-container',
  suggestionsContainerOpen: 'a-search-auto__suggestions-container--open',
  suggestionsList: 'a-search-auto__suggestions-list',
  suggestion: 'a-search-auto__suggestion',
  suggestionFirst: 'a-search-auto__suggestion--first',
  suggestionHighlighted: 'a-search-auto__suggestion--highlighted',
  sectionContainer: 'a-search-auto__section-container',
  sectionContainerFirst: 'a-search-auto__section-container--first',
  sectionTitle: 'a-search-auto__section-title'
};

export default SearchTheme;
